import Modal from "react-bootstrap/Modal";
import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import "../../Style/Checkbox.scss";
import { errorAlert, handleSuccess } from "../../Components/Alerts";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import "../../Style/__button.scss";
import "../ClientsCRUD/ClientsModal.scss";
import "./EmployeesModal.scss";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "react-select";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { AddElementsButton } from "../../Components/AddElementsButton";

function InsertEmployees(props) {
  const headers = authHeader();
  const isEditMode = props.mode === "edit";
  const normalizeBankAccount = (value = "") => value.replace(/\D/g, "");
  const formatBankAccount = (value = "") =>
    normalizeBankAccount(value).replace(/(.{4})/g, "$1 ").trim();

  const [accName, setAccName] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [vatNumber, setVatNumber] = useState("");
  const [adress, setAdress] = useState("");
  const [cityID, setCityID] = useState("");
  const [bankID, setBankID] = useState();
  const [bankAccount, setBankAccount] = useState("");
  const [accEmail, setAccEmail] = useState("");
  const [comment, setComment] = useState("");
  const [phone, setPhone] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [accountID, setAccountID] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [stateid, setStateID] = useState("");
  const [states, setStates] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);

  const [city, setCity] = useState([]);
  const [filteredCity, setFilteredCity] = useState([]);

  const [bank, setBank] = useState([]);
  const [filteredBank, setFilteredBank] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [stateName, setStateName] = useState("");
  const [cityName, setCityName] = useState("");
  const [bankName, setBankName] = useState("");

  const [stateError, setStateError] = useState("");
  const [cityError, setCityError] = useState("");
  const [accNameError, setAccNameError] = useState("");
  const [idNumberError, setIdNumberError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [bankAccountError, setBankAccountError] = useState("");

  const initialSnapshotRef = useRef(null);
  const [showConfirmClose, setShowConfirmClose] = useState(false);

  const resetForm = () => {
    setAccountID(null);
    setAccName("");
    setIdNumber("");
    setVatNumber("");
    setAdress("");
    setCityID("");
    setStateID("");
    setBankID();
    setBankAccount("");
    setAccEmail("");
    setComment("");
    setPhone("");
    setIsActive(true);
    setStateName("");
    setCityName("");
    setBankName("");
    setCity([]);
    setStateError("");
    setCityError("");
    setAccNameError("");
    setIdNumberError("");
    setAddressError("");
    setEmailError("");
    setPhoneError("");
    setBankAccountError("");
    setIsSubmitting(false);
    initialSnapshotRef.current = null;
    setShowConfirmClose(false);
  };

  const setFormFromEmployee = (employee) => {
    const formattedBankAccount = formatBankAccount(employee?.BankAccount ?? "");

    setAccountID(employee?.AccountID ?? null);
    setAccName(employee?.AccountName ?? "");
    setIdNumber(employee?.IdentificationNumber ?? "");
    setVatNumber(employee?.VATNumber ?? "");
    setAdress(employee?.Adress ?? "");
    setCityID(employee?.CityID ?? "");
    setStateID(employee?.StateID ?? "");
    setBankID(employee?.BankID ?? undefined);
    setBankAccount(formattedBankAccount);
    setAccEmail(employee?.Email ?? "");
    setComment(employee?.Comment ?? "");
    setPhone(employee?.PhoneNumbers ?? "");
    setIsActive(
      typeof employee?.IsActive === "boolean" ? employee.IsActive : true,
    );
    setStateName(employee?.StateName ?? "");
    setCityName(employee?.CityName ?? "");
    setBankName(employee?.BankName ?? "");
    setStateError("");
    setCityError("");
    setAccNameError("");
    setIdNumberError("");
    setAddressError("");
    setEmailError("");
    setPhoneError("");
    setBankAccountError("");
    setIsSubmitting(false);

    initialSnapshotRef.current = {
      accName: employee?.AccountName ?? "",
      idNumber: employee?.IdentificationNumber ?? "",
      vatNumber: employee?.VATNumber ?? "",
      adress: employee?.Adress ?? "",
      cityID: employee?.CityID ?? "",
      stateid: employee?.StateID ?? "",
      bankID: employee?.BankID ?? undefined,
      bankAccount: formattedBankAccount,
      accEmail: employee?.Email ?? "",
      comment: employee?.Comment ?? "",
      phone: employee?.PhoneNumbers ?? "",
      isActive:
        typeof employee?.IsActive === "boolean" ? employee.IsActive : true,
    };
  };

  useEffect(() => {
    axios
      .get(ApiLink.API_URL + "states", { headers })
      .then((response) => {
        setStates(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const fetchCityByState = async (selectedStateID) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Cities/getcitybystate",
        { headers, params: { stateid: selectedStateID } },
      );
      setCity(response.data);
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  useEffect(() => {
    axios
      .get(ApiLink.API_URL + "LicencedBanks", { headers })
      .then((response) => {
        setBank(response.data);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!props.show) {
      return;
    }

    if (isEditMode) {
      if (!props.initialData) {
        return;
      }

      setFormFromEmployee(props.initialData);
      if (props.initialData.StateID) {
        fetchCityByState(props.initialData.StateID);
      }
      return;
    }

    resetForm();
  }, [props.show, props.initialData, isEditMode]);

  useEffect(() => {
    setFilteredStates(
      states.filter((data) =>
        data.StateName.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
  }, [searchTerm, states]);

  useEffect(() => {
    setFilteredCity(
      city.filter((data) =>
        data.CityName.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
  }, [searchTerm, city]);

  useEffect(() => {
    setFilteredBank(
      bank.filter((data) =>
        data.BankName.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
  }, [searchTerm, bank]);

  const handleInputChange = (newValue) => {
    const inputValue = newValue.replace(/\W/g, "");
    setSearchTerm(inputValue);
  };

  const handleFilterState = (selectedOption) => {
    if (selectedOption && selectedOption.StateID) {
      setStateID(selectedOption.StateID);
      setCityID("");
      setCityName("");
      setCity([]);
      fetchCityByState(selectedOption.StateID);
      setStateName(selectedOption.label);
      setStateError("");
      setCityError("");
    } else {
      setStateID("");
      setStateName("");
      setCityID("");
      setCityName("");
      setCity([]);
    }
  };

  const handleFilterCity = (selectedOption) => {
    if (selectedOption && selectedOption.CityID) {
      setCityID(selectedOption.CityID);
      setCityName(selectedOption.label);
      setCityError("");
    } else {
      setCityID("");
      setCityName("");
    }
  };

  const handleFilterBank = (selectedOption) => {
    if (selectedOption && selectedOption.BankID) {
      if (selectedOption.BankID !== bankID) {
        setBankAccount("");
        setBankAccountError("");
      }
      setBankID(selectedOption.BankID);
      setBankName(selectedOption.label);
    } else {
      setBankID("");
      setBankName("");
      setBankAccount("");
      setBankAccountError("");
    }
  };

  const isDirty = useMemo(() => {
    if (!isEditMode) {
      return (
        accName.trim() !== "" ||
        idNumber !== "" ||
        vatNumber !== "" ||
        adress.trim() !== "" ||
        stateid !== "" ||
        cityID !== "" ||
        bankID != null ||
        bankAccount !== "" ||
        accEmail !== "" ||
        comment !== "" ||
        phone !== ""
      );
    }

    const snap = initialSnapshotRef.current;
    if (!snap) {
      return false;
    }

    return (
      accName !== snap.accName ||
      idNumber !== snap.idNumber ||
      vatNumber !== snap.vatNumber ||
      adress !== snap.adress ||
      cityID !== snap.cityID ||
      stateid !== snap.stateid ||
      bankID !== snap.bankID ||
      bankAccount !== snap.bankAccount ||
      accEmail !== snap.accEmail ||
      comment !== snap.comment ||
      phone !== snap.phone ||
      isActive !== snap.isActive
    );
  }, [
    isEditMode,
    accName,
    idNumber,
    vatNumber,
    adress,
    cityID,
    stateid,
    bankID,
    bankAccount,
    accEmail,
    comment,
    phone,
    isActive,
  ]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (isSubmitting) {
      return;
    }

    let hasValidationError = false;
    const trimmedAccName = accName.trim();
    const trimmedIdNumber = idNumber.trim();
    const trimmedAddress = adress.trim();
    const trimmedEmail = accEmail.trim();
    const trimmedPhone = phone.trim();
    const normalizedBankAccount = normalizeBankAccount(bankAccount);

    if (trimmedAccName === "") {
      setAccNameError("Plotësoni emrin e punonjësit");
      hasValidationError = true;
    } else {
      setAccNameError("");
    }

    if (trimmedIdNumber === "") {
      setIdNumberError("Plotësoni numrin identifikues");
      hasValidationError = true;
    } else {
      setIdNumberError("");
    }

    if (trimmedAddress === "") {
      setAddressError("Plotësoni adresën");
      hasValidationError = true;
    } else {
      setAddressError("");
    }

    if (trimmedEmail !== "") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(trimmedEmail)) {
        setEmailError("Email nuk është valid");
        hasValidationError = true;
      } else {
        setEmailError("");
      }
    } else {
      setEmailError("");
    }

    if (trimmedPhone !== "") {
      const phoneRegex = /^[0-9+\s()-]{6,20}$/;
      if (!phoneRegex.test(trimmedPhone)) {
        setPhoneError("Numri i telefonit nuk është valid");
        hasValidationError = true;
      } else {
        setPhoneError("");
      }
    } else {
      setPhoneError("");
    }

    if (normalizedBankAccount !== "") {
      const isBankAccountValid = normalizedBankAccount.length === 16;
      if (!isBankAccountValid) {
        setBankAccountError("Llogaria bankare duhet të jetë fiks 16 shifra");
        hasValidationError = true;
      } else {
        setBankAccountError("");
      }
    } else {
      setBankAccountError("");
    }

    if (stateid == null || stateid === "") {
      setStateError("Plotësoni shtetin");
      hasValidationError = true;
    } else {
      setStateError("");
    }

    if (cityID == null || cityID === "") {
      setCityError("Plotësoni qytetin");
      hasValidationError = true;
    } else {
      setCityError("");
    }

    if (hasValidationError) {
      return;
    }

    setIsSubmitting(true);

    const insertPayload = {
      AccountName: trimmedAccName,
      LedgerID: 310,
      IdentificationNumber: trimmedIdNumber,
      VatNumber: "",
      Adress: trimmedAddress,
      CityID: cityID,
      StateID: stateid,
      BankID: bankID,
      BankAccount: normalizedBankAccount,
      Email: trimmedEmail,
      Comment: comment,
      PhoneNumbers: trimmedPhone,
      IsActive: isActive,
    };

    const updatePayload = {
      AccountName: trimmedAccName,
      LedgerID: 310,
      IdentificationNumber: trimmedIdNumber,
      VATNumber: vatNumber,
      Adress: trimmedAddress,
      CityID: cityID,
      StateID: stateid,
      BankID: bankID,
      BankAccount: normalizedBankAccount,
      Email: trimmedEmail,
      Comment: comment,
      PhoneNumbers: trimmedPhone,
      IsActive: isActive,
      AccountID: accountID,
    };

    const submitRequest = isEditMode
      ? axios.put(ApiLink.API_URL + "Accounts/updateAccount", updatePayload, {
          headers,
        })
      : axios.post(ApiLink.API_URL + "Accounts/insertAccount", insertPayload, { headers });

    submitRequest
      .then(() => {
        handleSuccess(
          isEditMode
            ? "Punonjësi u përditësua me sukses"
            : "Punonjësi u shtua me sukses",
        );
        resetForm();
        props.onHide();
        props.refreshData();
      })
      .catch((error) => {
        console.error(error);
        if (error.response && error.response.status === 409) {
          errorAlert(error.response.data);
        } else {
          errorAlert("Ka ndodhur një gabim i panjohur gjatë përpunimit të kërkesës.");
        }
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const doClose = () => {
    if (isSubmitting) {
      return;
    }

    props.onHide();
    resetForm();
  };

  const handleClose = () => {
    if (isSubmitting) {
      return;
    }

    if (isDirty) {
      setShowConfirmClose(true);
      return;
    }

    doClose();
  };

  return (
    <>
      <Modal
        {...props}
        onHide={handleClose}
        backdrop={isSubmitting ? "static" : true}
        keyboard={!isSubmitting}
        size="lg"
        dialogClassName="clients-modal-dialog employees-modal-dialog"
        contentClassName="clients-modal-content employees-modal-content"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="clients-modal-header">
          <div className="clients-modal-header-content">
            <Modal.Title
              id="contained-modal-title-vcenter"
              className="clients-modal-title"
            >
              {isEditMode
                ? "Përditëso të dhënat e punonjësit"
                : "Krijo punonjës të ri"}
            </Modal.Title>
            <p className="clients-modal-subtitle">
              {isEditMode
                ? "Ndrysho të dhënat e punonjësit dhe ruaji për përditësim në sistem."
                : "Plotësoni të dhënat e punonjësit dhe ruani për ta shtuar në sistem."}
            </p>
            <div className="clients-modal-meta">
              <span className="clients-meta-pill">Fushat me * janë obligative</span>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body className="clients-modal-body">
          <form onSubmit={handleSubmit} className="clients-form">
            <section className="clients-section">
              <h6 className="clients-section-title">Informata Kryesore</h6>
              <div className="clients-grid clients-grid-2">
                <div className="clients-field clients-field-full">
                  <TextField
                    fullWidth
                    required
                    id="AccountName"
                    label="Emri Mbiemri i Punonjësit *"
                    variant="outlined"
                    type="text"
                    name="AccountName"
                    value={accName}
                    onChange={(event) => {
                      setAccName(event.target.value);
                      if (accNameError) {
                        setAccNameError("");
                      }
                    }}
                    autoComplete="off"
                    size="small"
                  />
                  <span className="clients-error">
                    {accNameError && `${accNameError}`}
                  </span>
                </div>

                <div className="clients-field">
                  <TextField
                    fullWidth
                    required
                    id="IdentificationNumber"
                    label="Numri Identifikues *"
                    variant="outlined"
                    type="text"
                    name="IdentificationNumber"
                    value={idNumber}
                    onChange={(event) => {
                      setIdNumber(event.target.value);
                      if (idNumberError) {
                        setIdNumberError("");
                      }
                    }}
                    autoComplete="off"
                    size="small"
                  />
                  <span className="clients-error">
                    {idNumberError && `${idNumberError}`}
                  </span>
                </div>

                <div className="clients-field">
                  <TextField
                    fullWidth
                    required
                    id="Adress"
                    label="Adresa *"
                    variant="outlined"
                    type="text"
                    name="Adress"
                    value={adress}
                    onChange={(event) => {
                      setAdress(event.target.value);
                      if (addressError) {
                        setAddressError("");
                      }
                    }}
                    autoComplete="off"
                    size="small"
                  />
                  <span className="clients-error">
                    {addressError && `${addressError}`}
                  </span>
                </div>

                <div className="clients-field">
                  <label className="clients-select-label">Përzgjedh Shtetin *</label>
                  <Select
                    inputId="StateID"
                    classNamePrefix="clients-select"
                    value={
                      stateid
                        ? { label: stateName, value: stateid, StateID: stateid }
                        : null
                    }
                    options={filteredStates.map((data) => ({
                      label: data.StateName,
                      value: data.StateID,
                      StateID: data.StateID,
                    }))}
                    onInputChange={handleInputChange}
                    onChange={handleFilterState}
                    isClearable
                    placeholder="Select"
                    noOptionsMessage={() => "Nuk u gjet asnjë përputhje"}
                    components={{ IndicatorSeparator: () => null }}
                  />
                  <span className="clients-error">
                    {stateError && `${stateError}`}
                  </span>
                </div>

                <div className="clients-field">
                  <label className="clients-select-label">Përzgjedh Qytetin *</label>
                  <Select
                    inputId="CityID"
                    classNamePrefix="clients-select"
                    value={
                      cityID
                        ? { label: cityName, value: cityID, CityID: cityID }
                        : null
                    }
                    options={filteredCity.map((data) => ({
                      label: data.CityName,
                      value: data.CityID,
                      CityID: data.CityID,
                    }))}
                    onInputChange={handleInputChange}
                    onChange={handleFilterCity}
                    isClearable
                    placeholder="Select"
                    noOptionsMessage={() => "Nuk u gjet asnjë përputhje"}
                    components={{ IndicatorSeparator: () => null }}
                  />
                  <span className="clients-error">
                    {cityError && `${cityError}`}
                  </span>
                </div>

                <div className="clients-field">
                  <label className="clients-select-label">Përzgjedh Bankën</label>
                  <Select
                    inputId="BankID"
                    classNamePrefix="clients-select"
                    value={
                      bankID
                        ? { label: bankName, value: bankID, BankID: bankID }
                        : null
                    }
                    options={filteredBank.map((data) => ({
                      label: data.BankName,
                      value: data.BankID,
                      BankID: data.BankID,
                    }))}
                    onInputChange={handleInputChange}
                    onChange={handleFilterBank}
                    isClearable
                    placeholder="Select"
                    noOptionsMessage={() => "Nuk u gjet asnjë përputhje"}
                    components={{ IndicatorSeparator: () => null }}
                  />
                </div>

                <div className="clients-field">
                  <label className="clients-select-label">Numri i Llogarisë</label>
                  <TextField
                    fullWidth
                    id="BankAccount"
                    variant="outlined"
                    type="text"
                    name="BankAccount"
                    value={bankAccount}
                    onChange={(event) => {
                      setBankAccount(formatBankAccount(event.target.value));
                      if (bankAccountError) {
                        setBankAccountError("");
                      }
                    }}
                    inputProps={{ maxLength: 19 }}
                    autoComplete="off"
                    disabled={!bankID}
                    placeholder={bankID ? "Shkruaj numrin e llogarisë" : "Fillimisht zgjidh bankën"}
                    size="small"
                  />
                  <span className="clients-error">
                    {bankAccountError && `${bankAccountError}`}
                  </span>
                </div>
              </div>
            </section>

            <section className="clients-section">
              <h6 className="clients-section-title">Kontakt dhe Koment</h6>
              <div className="clients-grid clients-grid-2">
                <div className="clients-field">
                  <TextField
                    fullWidth
                    id="Email"
                    label="Email"
                    variant="outlined"
                    type="text"
                    name="Email"
                    value={accEmail}
                    onChange={(event) => {
                      setAccEmail(event.target.value);
                      if (emailError) {
                        setEmailError("");
                      }
                    }}
                    autoComplete="off"
                    size="small"
                  />
                  <span className="clients-error">
                    {emailError && `${emailError}`}
                  </span>
                </div>

                <div className="clients-field">
                  <TextField
                    fullWidth
                    id="PhoneNumber"
                    label="Numri i Telefonit"
                    variant="outlined"
                    type="text"
                    name="PhoneNumber"
                    value={phone}
                    onChange={(event) => {
                      setPhone(event.target.value);
                      if (phoneError) {
                        setPhoneError("");
                      }
                    }}
                    autoComplete="off"
                    size="small"
                  />
                  <span className="clients-error">
                    {phoneError && `${phoneError}`}
                  </span>
                </div>

                <div className="clients-field clients-field-full">
                  <textarea
                    rows={2}
                    className="clients-notes"
                    id="Comment"
                    placeholder="Komenti"
                    name="Comment"
                    value={comment}
                    onChange={(event) => setComment(event.target.value)}
                    autoComplete="off"
                  />
                </div>

                {isEditMode && (
                  <div className="clients-field clients-field-full">
                    <label className="clients-active-toggle">
                      <input
                        type="checkbox"
                        checked={Boolean(isActive)}
                        onChange={(event) => setIsActive(event.target.checked)}
                        className="clients-active-checkbox"
                        disabled={isSubmitting}
                      />
                      <span className="clients-active-copy">
                        <span className="clients-active-title">Statusi i punonjësit</span>
                        <span className="clients-active-description">
                          {isActive ? "Punonjësi është aktiv në sistem" : "Punonjësi është joaktiv në sistem"}
                        </span>
                      </span>
                    </label>
                  </div>
                )}
              </div>
            </section>

            <div className="clients-modal-footer">
              <Button
                type="submit"
                variant="contained"
                className="clients-save-btn"
                disabled={isSubmitting || (isEditMode && !isDirty)}
              >
                {isSubmitting
                  ? "Duke ruajtur..."
                  : isEditMode
                    ? "Përditëso & Mbyll"
                    : "Ruaj & Mbyll"}
              </Button>
              <Button
                variant="outlined"
                className="clients-close-btn"
                onClick={handleClose}
                disabled={isSubmitting}
              >
                Mbyll
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Dialog
        open={showConfirmClose}
        onClose={() => setShowConfirmClose(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Konfirmo mbylljen</DialogTitle>
        <DialogContent>
          Keni ndryshime të paruajtura. Nëse mbyllni tani, të dhënat e ndryshuara do të humbin. A jeni të sigurt?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowConfirmClose(false)} variant="outlined">
            Kthehu
          </Button>
          <Button onClick={doClose} variant="contained" color="error">
            Po, mbyll pa ruajtur
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default function EmployeesModal(props) {
  const [internalModalShow, setInternalModalShow] = React.useState(false);
  const isControlled = typeof props.show === "boolean";
  const modalShow = isControlled ? props.show : internalModalShow;

  const openModal = () => {
    if (isControlled) {
      return;
    }

    setInternalModalShow(true);
  };

  const closeModal = () => {
    if (isControlled) {
      if (props.onHide) {
        props.onHide();
      }
      return;
    }

    setInternalModalShow(false);
  };

  const handleRefreshData = () => {
    if (props.fetchData) {
      props.fetchData();
    }
  };

  return (
    <>
      {!isControlled &&
        (props.type === "text" ? (
          <AddElementsButton
            text="Krijo punonjës"
            onClick={openModal}
            icon="bi bi-plus-circle"
            className="button-68"
          />
        ) : props.type === "insert" ? (
          <AddElementsButton
            text="Krijo punonjës"
            onClick={openModal}
            icon="bi bi-plus-circle"
            className="button-15"
          />
        ) : (
          <AddBoxIcon
            style={{ height: "30px", color: "black" }}
            onClick={openModal}
          />
        ))}

      <InsertEmployees
        show={modalShow}
        onHide={closeModal}
        refreshData={handleRefreshData}
        mode={props.mode}
        initialData={props.initialData}
      />
    </>
  );
}
